import React,{useEffect,useState} from "react";
import { Routes, Route, BrowserRouter, Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import { PrivateRoute } from "routes/privateRoute";
import Login from "pages/Login";
import ClaimsManager from "pages/ClaimsManager";
import Providers from "pages/Providers";
import Fax from "pages/Fax";
import Patient from "pages/Patient";
import NotValidTab from "pages/NotValidTab";
import Location from "pages/Location";
import PurchaseOrders from "pages/PurchaseOrder";
import Dashboard from "pages/Dashboard";
import InventorySearch from "pages/InventorySearch";
import Invoice from "pages/Invoice";
import Reports from "pages/Reports";
import UserManagement from "pages/UserManagement";
import Configuration from "pages/Configuration";
import Contracts from "pages/Contracts";
import FileMonitoring from "pages/FileMonitoring";
import PayorSearch from "pages/Payor";
import FormularySearch from "pages/Formulary";
import BiToolSearch from "pages/BITool";
import { ModuleAccess } from "utils/moduleaccess";
import RxManager from "pages/Rx-Manager";
import DrugCatalog from "pages/DrugCatalog";
import "./index.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";



const queryClient = new QueryClient();

const App = () => {
  const [modules, setModules] = useState([])

  useEffect(() => {
    ThemeSelector();
    fetchModules();
  }, [])
  const fetchModules = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const { sub } = profile || {};
    try {
      if (access_token) {
        renderDashboard();
        renderPurchaseOrders();
        renderInventorySearch();
        renderInvoice();
        renderReports();
        renderContracts();
        renderConfiguration();
        renderFormularySearch();
        renderRxManager();
        renderDrugCatalogue();
      }

      // const { data } = await axios.get(
      //   `${process.env.REACT_APP_ENDPOINT}/RCMConfig/app/modules`,
      //   {
      //     //params: { Id: sub },
      //     headers: {
      //       'Content-type': 'application/json',
      //       Authorization: `${token_type} ${access_token}`,
      //     },
      //   }
      // );
      // if (data) {
      //   setModules(data);
      // }

    } catch (error) {
      console.log(error.message);
    }
  };

  const ThemeSelector = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub } = profile || {};
    console.log(sub,"sub")
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/GWConfig/app/userapptheme`,
        {
          params: { Id: sub },
          headers: {
            "Content-type": "application/json",
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      if (data) {
        import("./style/pfapp.scss");
        // let themeid = data;
        // localStorage.setItem('theme', themeid);
        // if (themeid === "PF") {
        //   import('./style/pfapp.scss');
        // }
        // else if (themeid === "CPS") {
        //   import('./style/app.scss');
        // }
      }
    } catch (error) {
      // (error.message);
    }

    return <></>;
  };

  

  const renderDashboard = () => {
    //let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("DB", '')) {
      return (<Route path='/dashboard' element={<Dashboard module={module[0]} />} />)
    }
  }
  const renderPurchaseOrders = () => {
  //  let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("PO", "")) {
      return (<Route path="/purchase-orders" element={<PurchaseOrders module={module[0]} />} />)
    }
  }
  const renderInventorySearch = () => {
    //let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("INV", "")) {
      return (<Route path="/inventory-search" element={<InventorySearch module={module[0]} />} />)
    }
  }
  const renderInvoice = () => {
    if (ModuleAccess("INVOICE", "")){
      return (<Route path='/invoice' element={<Invoice module={module[0]} />} />)
    }
  }
  const renderReports = () => {
    //let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("REP", "")) {
      return (<Route path='/reports' element={<Reports module={module[0]} />} />)
    }
  }
  const renderContracts = () => {
    //let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("CON", "")) {
      return (<Route path='/contracts' element={<Contracts module={module[0]} />} />)
    }
  }
  const renderConfiguration = () => {
    //let module = modules.filter(m => m.code == "TB");
      if (ModuleAccess("CONFIG", '')) {
      return (<Route path='/configuration' element={<Configuration module={module[0]} />} />)
      }
  }
  const renderFormularySearch = () => {
    //let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("FOR", '')) {
      return (<Route path='/formulary' element={<FormularySearch module={module[0]} />} />)
    }
  }
  
  const renderRxManager = () => {
    if (ModuleAccess("RXM", "")){
      return ( <Route path="/rx-manager" element={<RxManager module={module[0]}  />}/>)
    }
  };

  const renderDrugCatalogue = () => {
    if (ModuleAccess("DC", "")) {
      return (<Route path='/drugcatalog' element={<DrugCatalog module={module[0]} />} />)
    }
  }


  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Outlet />}>
            <Route element={<PrivateRoute  />}>
              <Route index element={<Login />} />
              <Route index path="/login" element={<Login />} />
              {/* {renderConfiguration()} */}
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}
              
              <Route path="/claims-manager" element={<ClaimsManager />} />
              {renderConfiguration()}
              {/* <Route path="/configuration" element={<Configuration />} /> */}
              {renderDashboard()}
              {/* {renderContracts()}
              <Route path="/contracts" element={<Contracts />} /> */}
              <Route path="/file-monitoring" element={<FileMonitoring />} />
              {renderPurchaseOrders()}
              {/* <Route path="/purchase-orders" element={<PurchaseOrders />} /> */}
              <Route path="/providers" element={<Providers />} />
              <Route path="/fax" element={<Fax />} />
              {renderInventorySearch()}
              {/* <Route path="/inventory-search" element={<InventorySearch />} /> */}
              <Route path="/payor" element={<PayorSearch/>} />
              {renderInvoice()}
              {/* <Route path="/invoice" element={<Invoice/>} /> */}
              {renderFormularySearch()}
              {/* <Route path="/formulary" element={<FormularySearch/>} /> */}
              <Route path="//bi-tool" element={<BiToolSearch/>}/>
              {renderReports()}
              <Route path="/reports" element={<Reports />} />
            
              <Route path="/user-management" element={<UserManagement />} />
              <Route
                path="/claims-manager/:coveredEntityID/:tenantID/patient/:patientId"
                element={<Patient />}
              />
              <Route path="/location" element={<Location />} />
              {renderRxManager()}
              {renderDrugCatalogue()}
              {/* <Route path="/rx-manager" element={<RxManager />} /> */}
              <Route path="/drugcatalog" element={<DrugCatalog />} />

              {/* <Route path="configuration" element={<Configuration />} /> */}
              {renderConfiguration()}
              {/* <Route path="configuration" element={<Configuration />} /> */}
            </Route>
           
            

            {/* catch all */}
            <Route path="*" element={<NotValidTab />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </QueryClientProvider>
  );
};

export default App;
